import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-edit-icon',
  templateUrl: './lib-edit-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibEditIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
